import { SimulationTask } from './simulation-task.class';

export class YearlySaving {
	year: number;
	baseSaving: number;
	worstCaseSaving: number;
	bestCaseSaving: number;
	co2Total: number;
	vehiclesElectrified: SimulationTask[];
}
